<template>
  <div
    id="percent"
    :class="{
      'percent-green': positivePercent,
      'percent-red': negativePercent,
      'percent-zero': zeroPercent,
      'not-arrow': !showArrow,
    }"
  >
    <template v-if="showArrow && !zeroPercent">
      <v-icon
        v-if="positivePercent"
        class="positive-arrow"
        size="16"
        :color="$vuetify.theme.dark ? 'white' : 'darkGreen'"
      >
        mdi-arrow-up
      </v-icon>
      <v-icon
        v-if="negativePercent"
        class="negative-arrow"
        size="16"
        :color="$vuetify.theme.dark ? 'white' : 'darkRed'"
      >
        mdi-arrow-down
      </v-icon>
    </template>

    <template v-if="type === 'net'">
      <currency :value="value" :currency="currency" :showNegative="false" />
    </template>
    <template v-else-if="type === 'percent'">
      <currency neverHide :value="value" :showNegative="false" />
      %
    </template>
  </div>
</template>

<script>
import Currency from '@/views/components/common/Currency'

export default {
  components: { Currency },
  props: {
    type: {
      type: String,
      required: true,
    },
    value: {
      type: Number,
      required: true,
    },
    currency: {
      type: String,
      default: '',
    },
    showArrow: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    negativePercent() {
      return this.value < 0
    },
    positivePercent() {
      return this.value > 0
    },
    zeroPercent() {
      return this.value === 0
    },
  },
}
</script>

<style lang="scss">
#percent {
  width: 100%;
  min-width: 100px;
  &.percent-red {
    background: #fce8e6;
    color: #a50e0e;
  }
  &.percent-green {
    background: #e6f4ea;
    color: #137333;
  }
  &.percent-zero {
    background: #f7f8fb;
    color: #000;
  }
  font-weight: 500;
  border-radius: 5px;
  padding: 1px 6px 1px 4px;
  font-size: 13px;
  display: flex;
  align-items: center;
  justify-content: center;
  &.not-arrow {
    padding: 1px 6px 1px 6px;
  }

  .positive-arrow {
    margin-bottom: 2px;
    margin-right: 2px;
  }
  .negative-arrow {
    // margin-top: 1px;
    margin-right: 2px;
  }
}

.theme--dark {
  #percent {
    &.percent-red {
      background: #5d1f1a;
      color: white;
    }
    &.percent-green {
      background: #174b35;
      color: white;
    }
    &.percent-zero {
      background: #5b5b5b;
      color: white;
    }
  }
}
</style>
